import { gql } from '@apollo/client'

import TEAM_FRAGMENT from './components/Team/fragments'

export default gql`
  query About {
    team: people(perPage: 100, isSuperhi: true, sort: { direction: ASC, key: STARTED_ON }) {
      ...TeamComponent
    }
  }

  ${TEAM_FRAGMENT}
`
